import React from "react";
import { Link } from "react-router-dom";
import BubbleTalk from "components/BubbleTalk";
import scenarios from "data/scenarios";
import bodyTalkLogo from "assets/logos/body-talk-logo.png";
import familyPlanningLogo from "assets/logos/fpnsw-logo.png";
import SvgHome from "components/Images/home/SvgHome";
import { motion } from "framer-motion";
import "./homepage.scss";

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
      delayChildren: 0.3,
    },
  },
};

const item = {
  hidden: { scale: 0 },
  show: { scale: 1 },
};

const home = {
  heading: "All about consent, sex and relationships",
  description: "Want to know more about navigating intimate relationships? Check out the following options and choose your own adventure.",
};

const Home = () => {
  return (
    <div className="homepage">
      <div className="homepage__inner">
        <div className="homepage__header">
          <motion.div className="homepage__logos" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
            <a href="https://bodytalk.org.au/" target="_blank" rel="noreferrer" className="body-talk-logo logo-item">
              <img src={bodyTalkLogo} alt="body-talk" />
            </a>
            <a href="https://www.fpnsw.org.au/" target="_blank" rel="noreferrer" className="family-planning-logo logo-item">
              <img src={familyPlanningLogo} alt="family-planning-nsw" />
            </a>
          </motion.div>
          <motion.div className="homepage__content padding-horizontal" initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.3 }}>
            <div className="homepage__heading">{home.heading}</div>
            <div className="homepage__description">{home.description}</div>
          </motion.div>
        </div>
        <motion.div className="homepage__items-listing padding-horizontal" variants={container} initial="hidden" animate="show">
          {Object.keys(scenarios).map((key) => (
            <motion.div key={scenarios[key].title} className="scenario-item" variants={item} transition={{ duration: 0.25 }}>
              <Link to={scenarios[key].path}>
                <BubbleTalk backgroundColor={scenarios[key].backgroundColor}>
                  <div className="scenario-bubble">
                    <div className="scenario-bubble-title">{scenarios[key].title}</div>
                    <div className="scenario-bubble-description">{scenarios[key].description}</div>
                  </div>
                </BubbleTalk>
              </Link>
            </motion.div>
          ))}
        </motion.div>
        <div className="homepage__background-image">
          <SvgHome />
        </div>
      </div>
      <div className="color-line">
            <span className="color-box"></span>
            <span className="color-box"></span>
            <span className="color-box"></span>
          </div>
    </div>
  );
};

export default Home;
